import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-progress-indictor-circle',
    templateUrl: './progress-indictor-circle.component.html',
    styleUrls: ['./progress-indictor-circle.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ProgressIndictorCircleComponent implements OnInit {
  static readonly componentName = 'ProgressIndictorCircleComponent';
  
  @Input() progress: number;
  @Input() showPercentage: boolean = false;
  @Input() isComplete: boolean = false;

  completePercent = 100;
  constructor() {}

  ngOnInit(): void {}
}
